/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForStructure extends models.ServiceAccountNativeDetailsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForStructure");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForStructure.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForStructure>): ServiceAccountNativeDetailsBaseForStructure {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForStructure(), model);
        ServiceAccountNativeDetailsBaseForStructure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForStructure>): ServiceAccountNativeDetailsBaseForStructure {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForStructure.newInstance(<ServiceAccountNativeDetailsBaseForStructure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForStructure) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForStructure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForStructure): boolean {
        if (models.ServiceAccountNativeDetailsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForStructure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
